import * as React from 'react';
import classNamesFn from 'classnames';

import { VectorImageProps } from '../VectorImage.types';
import Link from '../../Link/viewer/Link';
import { replaceCompIdPlaceholder } from '../../../core/commons/vectorImageUtils';
import { isEmptyObject } from '../../../core/commons/utils';
import styles from './style/VectorImage.scss';

const VectorImage: React.FC<VectorImageProps> = ({
  id,
  svgContent,
  shouldScaleStroke,
  withShadow,
  link,
  className = '',
  containerClass = '',
  onClick,
  onDblClick,
  onMouseEnter,
  onMouseLeave,
  hasPlatformClickHandler,
}) => {
  const classes = classNamesFn(
    styles.svgRoot,
    {
      [styles.nonScalingStroke]: !shouldScaleStroke,
      [styles.overflowVisible]: withShadow,
      [styles.clickable]: hasPlatformClickHandler,
    },
    className,
  );
  const svgContentElement = (
    <div
      data-testid={`svgRoot-${id}`}
      className={classes}
      dangerouslySetInnerHTML={{
        __html: svgContent && replaceCompIdPlaceholder(svgContent, id),
      }}
    />
  );
  return (
    <div
      id={id}
      className={containerClass}
      onClick={onClick}
      onDoubleClick={onDblClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {!isEmptyObject(link) ? (
        <Link className={styles.link} {...link}>
          {svgContentElement}
        </Link>
      ) : (
        svgContentElement
      )}
    </div>
  );
};

export default VectorImage;
